// * 베타 기준:
// - 개발 모드
// - window.location.host에 34.64.242.58 또는 amyhero가 포함
export const isBeta =
  process.env.NODE_ENV === "development" ||
  window.location.host?.includes("34.64.242.58") ||
  window.location.host?.includes("amyhero") ||
  window.location.host?.includes("beta.linkid.pw") ||
  window.location.host?.includes("beta.linkid.pw")
    ? true
    : false;
